import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_NUMERIC } from '../../data/content';
import { trackPixelEvent } from '../../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  full?: boolean;
}
export function CtaButton({
  children,
  size = 'lg',
  full = true
}: CtaButtonProps) {
  const sizeClass = size === 'lg' ? 'px-8 py-5 text-base' : 'px-6 py-4 text-sm';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'El Profe de Guitarra — Pack completo',
      value: PRICE_NUMERIC,
      currency: 'ARS'
    });
  };
  return <a href={CHECKOUT_URL} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-amber font-semibold uppercase tracking-wide text-ink shadow-lift transition-colors duration-150 ease-out hover:bg-amber-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${sizeClass} ${full ? 'w-full' : ''}`} data-id="element-267" data-mp="1d6kko8ceeaef">
      <span className="text-center leading-tight" data-id="element-268" data-mp="2hintp1fazewp">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-269" data-mp="2ch88n9d4l8eb" />
    </a>;
}